// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"83f9b964","99":"51386bc9","126":"23283547","200":"0753687b","263":"affcf4e2","316":"9e623040","364":"8d1d7c7e","404":"51bbdbde","536":"78bc381a","605":"ed45c707","739":"adba78da","817":"d2ae5416","835":"9db42c25","891":"f36128ce"}[chunkId] + ".chunk.js";
};